module.exports = __webpack_public_path__ + "static/media/feedbellie.a99b2c3d.png";